import classNames from 'classnames';
import React, { Component } from 'react';
import { FormFeedback } from 'reactstrap';

class ValidatingSelect extends Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const errorFeedback = nextProps.validationFn(nextProps.value);
    return {
      errorFeedback,
      isBlurred: prevState.isBlurred,
      isValid: !errorFeedback,
      value: nextProps.value,
      wasValid: prevState.wasValid
        ? true
        : !errorFeedback,
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      errorFeedback: null,
      isBlurred: false,
      isValid: !this.props.required,
      value: this.props.initialValue || '',
      wasValid: false,
    };
    this.handleBlur = this.handleBlur.bind(this);
    this.handleInput = this.handleInput.bind(this);
  }

  // ----------------------
  // Computed
  // ----------------------

  get applyInvalidCssClass() {
    return (
      (this.state.isBlurred && !this.state.isValid) ||
      (this.state.wasValid && !this.state.isValid)
    );
  }

  get classNames() {
    return classNames('form-control', {
      'is-invalid': this.applyInvalidCssClass,
    });
  }

  // get errorFeedback() {
  //   return `${this.props.label} is required.`;
  // }

  // ----------------------
  // Methods
  // ----------------------

  handleBlur() {
    if (!this.state.isBlurred) {
      this.setState({ isBlurred: true });
    }
    this.props.onChange({
      isValid: this.state.isValid,
      name: this.props.name,
      value: this.state.value,
    });
  }

  handleInput(event) {
    const { name, value } = event.target;
    this.props.onChange({
      isValid: !this.props.validationFn(value),
      name,
      value,
    });
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <div className="form-group">
        <label htmlFor={this.props.name}>
          {this.props.label}:
          {this.props.required && <i className="fa fa-asterisk" />}
        </label>
        <select
          className={this.classNames}
          disabled={!this.props.options}
          id={this.props.name}
          name={this.props.name}
          onBlur={this.handleBlur}
          onChange={this.handleInput}
          value={this.state.value}
        >
          <option value="">Select Object to Tag</option>
          {this.props.options && this.props.options.map((option, index) => (
            <option key={(index + 1).toString()} value={option.value}>
              {option.name}
            </option>
          ))}
        </select>
        <FormFeedback>{this.state.errorFeedback}</FormFeedback>
      </div>
    );
  }
}

export default ValidatingSelect;
